/**
 * @file   知识检索搜索頁
 * @create macaiqi 2021/11/30
 * @update
 */
import React, { useEffect, useState } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { htmltoStr } from '@/utils';
import cls from 'classnames';
import SearchComponent from '../KnowledgeRetrieval/SearchComponent';
import usePage from '../../../components/Hooks/usePage';
import { GetQueryString } from '../../../../utils';
import { Pager } from '@portal-site/pager';
import Bread from '../../common/Bread';
import { fullTextSearch, queryRecommend } from '../../../shared/api';
import Label from './component/Label';
import Loading from '../../../components/Loading';
import './index.scss';
const Icon = ({ conceptName, conceptCode }) => {
  // return conceptName === '人物' ? (
  //   <i className={cls('iconfont icon-icon03 ', { conceptCode })} />
  // ) : conceptName.includes('建筑') ? (
  //   <i className="iconfont icon-jianzhu" />
  // ) : null;
  return (
    <div className="icon-bg">
      <i className={cls(conceptCode)} />
    </div>
  );
};
const One = ({ records }) => {
  const history = useHistory();
  let name;
  const imgsrc =  records?.showImage || records?.files[0]?.fileThumbnail ||records?.files[0]?.filePath;
  return (
    <div className="one">
      <div className="one-l">
        {imgsrc ? (
          <img src={`${window.ENV_IMG_PREURL_SRC}/${imgsrc}`} alt="" />
        ) : (
          <div className="noimg" />
        )}
      </div>
      <div className="one-r">
        <Link to={`/Subject/${records.conceptCode}/${records.instanceId}`} target='_blank'>
          <h3>
            <span>{records.instanceName}</span>
            <Icon conceptName={records.conceptName} conceptCode={records.conceptCode} />
          </h3>
        </Link>

        <div className="tip">
          {records.showAttrTriples?.map((item, index) => {
            name = '';
            records?.attrTriples.forEach((i) => {
              if (i.englishCode === item) {
                name = i.relationshipName;
              }
            });
            return (
              name &&
              records?.properties[item] !== 'none' &&
              item !== 'description' && (
                <div className="item" key={index}>
                  <span className="name">{htmltoStr(name)}：</span>
                  <span>{records?.properties[item] || '不详'}</span>
                </div>
              )
            );
          })}
        </div>
        <div
          className="content"
          dangerouslySetInnerHTML={{ __html: records.properties.description }}
        />
        <div className="last">
          {records?.tagTriples?.map((item, index) => {
            return (
              <span
                key={index}
                onClick={() => {
                  history.push({
                    pathname: '/KnowledgeSearch',
                    search: `${'key=' + item.tagName}`
                  });
                }}
              >
                {item.tagName}
              </span>
            );
          })}
        </div>
      </div>
    </div>
  );
};
// 左边搜索列表
const SearList = ({ records, instanceResults }) => {
  return (
    <div className="search-list">
      {instanceResults?.length > 0 &&
        instanceResults?.map((item, index) => {
          return (
            <Link
              to={`/Subject/${item.conceptCode}/${item.instanceId}`}
              className="item"
              key={index}
              target="_blank"
            >
              <div className="title">
                <span dangerouslySetInnerHTML={{ __html: item.instanceName }} />
                <Icon conceptName={item.conceptName} conceptCode={item.conceptCode} />
                {item.relationshipName && (
                  <div className="relationship">{item.relationshipName}</div>
                )}
              </div>
              <div
                className="cont"
                dangerouslySetInnerHTML={{ __html: item.properties.description }}
              />
            </Link>
          );
        })}
      {records?.map((item, index) => {
        return (
          <Link to={`/Subject/${item.conceptCode}/${item.instanceId}`} className="item" key={index} target="_blank">
            <div className="title">
              <span dangerouslySetInnerHTML={{ __html: item.instanceName }} />
              <Icon conceptName={item.conceptName} conceptCode={item.conceptCode} />
              {item.relationshipName && <div className="relationship">{item.relationshipName}</div>}
            </div>
            <div className="cont" dangerouslySetInnerHTML={{ __html: item.description }} />
          </Link>
        );
      })}
    </div>
  );
};
// 右侧相关
const Related = ({ instance }) => {
  const [data, setDate] = useState();
  useEffect(() => {
    // {
    //   conceptId: '7faf173fe48f4352a8083003f47c731f',
    //   instanceId: '3b420348f53a4e4fa4817c04d0cbdc57'
    // }
    if (instance) {
      queryRecommend({
        conceptId: instance?.conceptId,
        instanceId: instance?.instanceId
      }).then((res) => {
        setDate(res);
      });
    }
  }, [instance]);
  return (
    <div className="related">
      {data?.map((item, index) => {
        return (
          <div className="box" key={index}>
            <p className="tip">
              {item.conceptId && '相关'}
              {item.conceptName || item.attributeTitle}
            </p>
            <div className="line">
              {item?.instanceBeans?.map((item1, index1) => {
                return (
                  <Link
                    to={`/Subject/${item1.properties?.nodeId}/${item1.properties?.nodeId}`}
                    className="item"
                    key={index1}
                    target="_blank"
                  >
                    {item1.properties?.files?.[0]?.fileThumbnail ? (
                      <div className="imgbox">
                        <img
                          src={`${window.ENV_IMG_PREURL_SRC}/${item1.properties?.files?.[0]?.fileThumbnail}`}
                          alt=""
                        />
                      </div>
                    ) : (
                      <div className="noimg" />
                    )}

                    <p className="scrolltext">{item1.properties.nodeName}</p>
                  </Link>
                );
              })}
            </div>
          </div>
        );
      })}
    </div>
  );
};
const KnowledgeSearch = () => {
  const [initPage, setPage] = usePage(GetQueryString('page') || 1);
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState();

  const key = GetQueryString('key');
  useEffect(() => {
    setLoading(true);
    fullTextSearch({
      content: key,
      current: initPage,
      size: 10
    }).then((res) => {
      setData(res);
      setLoading(false);
    });
  }, [initPage, key]);
  return (
    <div className="knowledgesearch-page">
      <Bread title="知识检索" />
      <div className="knowledgesearch">
        <div className="l">
          <SearchComponent />
          {!loading ? (
            <>
              <p className="searchdata">搜索结果约{data?.total}条</p>
              {data?.records?.instance && <One records={data?.records?.instance} />}
              {(data?.records?.indexResult || data?.records || data?.instanceResults) && (
                <SearList
                  records={data?.records?.indexResult || data?.records}
                  instanceResults={data?.records?.instanceResults}
                />
              )}
              {data?.total > 1 && (
                <Pager
                  containerClassName="mypager"
                  forcePage={initPage || 1}
                  pageCount={data?.pages}
                  // total={data?.total}
                  onPageChange={(page) => setPage(page)}
                  // showLast={false}
                  // showFirst={false}
                  prevLabel="上一页"
                  nextLabel="下一页"
                  // showTotal
                />
              )}
            </>
          ) : (
            <Loading />
          )}
        </div>

        <div className="r">
          <Label keyword={key} />
          <Related instance={data?.records?.instance} />
        </div>
      </div>
    </div>
  );
};
export default KnowledgeSearch;
